module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8462/img/footerCmsFree.png"